import React from "react";
import "@frameworks/web/stylesheets/components/generic/radioButton.scss";
const RadioButton = (props) => {
    const moduleName = props.moduleName ? props.moduleName : "";
    return (React.createElement("div", { className: `radio-button ${props.className}` },
        React.createElement("label", { className: "radio_btn " + moduleName },
            React.createElement("input", { type: "radio", value: props.list.value, name: props.name, key: props.list.value, checked: props.selected === props.list.value, onChange: props.onChange, disabled: props.disabled ? props.disabled : false }),
            React.createElement("span", { className: "disp_val EncodeSans_16_500 txt_blackOne1" }, props.list.display))));
};
export default RadioButton;
